/**
 *
 * @param input number to round
 * @param decimalPoints number of decimal points to round to
 * @returns string representation of number, rounded only if needed
 */
export function toFixed(input: number, decimalPoints: number = 2): string {
  return input.toFixed(decimalPoints).replace(/[.,]00$/, "");
}

/**
 * Lektionstal ligger på et to-decimalers gitter. Serveren afrunder til det gitter
 * (cle-compliance-api round_lessons, .NET LessonMath.Round), så det her handler om
 * at holde klientens beregninger og visning på samme gitter — ikke om at validere.
 */
export const LESSON_DECIMALS = 2;

/**
 * Afrunder et lektionstal til to decimaler. Bruges som værn mod flydende-komma-støj,
 * når indberettede linjer lægges sammen (0.1 + 0.2 skal give 0.3, ikke 0.30000000000000004).
 */
export function roundLessons(input: number): number {
  return Number(input.toFixed(LESSON_DECIMALS));
}

/**
 * Formaterer et lektionstal til visning med dansk komma og uden efterfølgende nuller,
 * så 12 vises som "12", 12,3 som "12,3" og 12,34 som "12,34".
 */
export function formatLessons(input: number | null | undefined): string {
  if (input == null) return "-";

  return roundLessons(input).toLocaleString("da-DK", {
    maximumFractionDigits: LESSON_DECIMALS,
  });
}
